module.exports = __webpack_public_path__ + "static/vaishali-3605bce2dc673b593a7b6bc507f9d816.jpg";